import { useMemo } from 'react'

import DatePicker from 'material/DatePicker'

import { useAppCycleEndDate, useAppCycleStartDate } from './app-round-helper'
import { useFocusedApplicationCycle } from '../AppRoundProvider'

const getMinDate = (cutoffDate?: string, fallback?: Date) => (cutoffDate ? new Date(cutoffDate) : fallback)

type MaterialsDeadlineDateProps = {
  onUpdate: (update: string) => void
  onError: (error?: React.ReactElement) => void
  cutoff?: string
  materialsDeadline?: string
}

const MaterialsDeadlineDatePicker = ({ onUpdate, cutoff, materialsDeadline, onError }: MaterialsDeadlineDateProps) => {
  const applicationCycle = useFocusedApplicationCycle()

  const fallback = useAppCycleStartDate(applicationCycle)
  const minDate = useMemo(() => getMinDate(cutoff, fallback), [cutoff, fallback])
  const maxDate = useAppCycleEndDate(applicationCycle)
  return (
    <DatePicker
      required
      fullWidth
      date={materialsDeadline}
      onChange={onUpdate}
      onError={onError}
      autoOk
      label="Material Deadline Date"
      placeholder="MM/DD/YYYY"
      FormHelperTextProps={{ role: 'alert' }}
      format="MM/dd/yyyy"
      minDateMessage="The materials date cannot precede today nor the cutoff date"
      maxDateMessage="Date cannot be after July 31 of the academic year"
      invalidDateMessage="Must be formatted to MM/DD/YYYY"
      disablePast
      minDate={minDate}
      maxDate={maxDate}
      id="materials-date"
    />
  )
}

export default MaterialsDeadlineDatePicker
